import { service } from '@ember/service';
import Modifier from 'ember-modifier';
import type ModalService from 'walden-fast/services/modal';
import { registerDestructor } from '@ember/destroyable';

interface ModalSignature {
  Element: HTMLDialogElement;
  Args: {
    Positional: [string];
  };
}

export default class ModalModifier extends Modifier<ModalSignature> {
  @service('modal') declare modal: ModalService;

  modify(element: HTMLDialogElement, [id]: [string]): void {
    this.modal.register(id, element);
    registerDestructor(this, () => {
      this.modal.unregister(id);
    });
  }
}
